module.exports = __webpack_public_path__ + "img/Icon awesome-car-alt.9ac4dfdb.png";